import newIcon from "../assets/new.png";
import discoverIcon from "../assets/discover.png";
import gamesIcon from "../assets/games.png";
import spinnerIcon from "../assets/spinner.png";
import collectionsIcon from "../assets/collections.png";

export type NavRole = "teacher" | "student";

export interface IconNavItem {
  path: string;
  roles: NavRole[];
  iconSrc: string;
  iconAlt: string;
  label: string;
}

export interface TextNavItem {
  path: string;
  label: string;
  roles: NavRole[];
}

export const primaryIconNavItems: IconNavItem[] = [
  {
    path: "/your-collections",
    roles: ["teacher", "student"],
    iconSrc: collectionsIcon,
    iconAlt: "Collections",
    label: "Collections",
  },
  {
    path: "/new-collection",
    roles: ["teacher", "student"],
    iconSrc: newIcon,
    iconAlt: "New",
    label: "New Collection",
  },
  {
    path: "/discover-collections",
    roles: ["teacher", "student"],
    iconSrc: discoverIcon,
    iconAlt: "Discover",
    label: "Discover",
  },
  {
    path: "/games",
    roles: ["teacher", "student"],
    iconSrc: gamesIcon,
    iconAlt: "Games",
    label: "Games",
  },
  {
    path: "/name-generator",
    roles: ["teacher"],
    iconSrc: spinnerIcon,
    iconAlt: "Spinner",
    label: "Name Generator",
  },
];

export const secondaryTextNavItems: TextNavItem[] = [
  { path: "/your-collections", label: "Home", roles: ["teacher", "student"] },
  { path: "/about", label: "About", roles: ["teacher", "student"] },
  { path: "/shop", label: "Shop", roles: ["teacher", "student"] },
  { path: "/resources", label: "Resources", roles: ["teacher", "student"] },
  { path: "/credits", label: "Credits", roles: ["teacher", "student"] },
];

export const accountNavItems: TextNavItem[] = [
  {
    path: "/badges-achievements",
    label: "Badges",
    roles: ["teacher", "student"],
  },
  {
    path: "/milestones",
    label: "Milestones",
    roles: ["teacher", "student"],
  },
  { path: "/my-account", label: "My Account", roles: ["teacher", "student"] },
  { path: "/reports", label: "Reports", roles: ["teacher", "student"] },
  { path: "/settings", label: "Settings", roles: ["teacher", "student"] },
];
